"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        const GLOBAL_FILTER_BINDING_MIN_RESULTS_FOR_SEARCH = '10';
        const TEXT_SEARCH_OPERATORS = ['Contains', 'NotContains', 'StartsWith', 'NotStartsWith', 'EndsWith', 'NotEndsWith'];
        function referencesGlobalFilterInCriteria(filter, filterId) {
            if (!filter)
                return false;
            if (filter.globalFilterId === filterId)
                return true;
            return (filter.groupConditions || []).some(g => referencesGlobalFilterInCriteria(g, filterId));
        }
        function referencesGlobalFilterInAggCriteria(filter, filterId) {
            if (!filter)
                return false;
            if (filter.globalFilterId === filterId)
                return true;
            return (filter.groupConditions || []).some(g => referencesGlobalFilterInAggCriteria(g, filterId));
        }
        class GlobalFilterBindingsEditor extends distill.EditorBase {
            constructor() {
                super(...arguments);
                this._lastSignature = null;
            }
            init() {
                this.$list = this.$editor.find('.global-filter-bindings-list');
            }
            update() {
                const component = this.component;
                const filters = this.getGlobalFilters();
                const datasetRefs = dashboards.getDatasetRefsInDataQuery(component.dataQuery0);
                if (datasetRefs.length === 0 || filters.length === 0) {
                    this._lastSignature = null;
                    this.$list.empty();
                    this.setVisibility(false);
                    return;
                }
                const referencedIds = filters
                    .filter(f => this.isFilterOverridden(component, f.id))
                    .map(f => f.id)
                    .join(',');
                const bindings = this.getValueForEdit() || [];
                const bindingTargets = bindings
                    .map(b => { var _a, _b, _c, _d; return `${b.globalFilterId}:${(_a = b.datasetIndex) !== null && _a !== void 0 ? _a : ''}:${(_b = b.columnId) !== null && _b !== void 0 ? _b : ''}:${(_c = b.metricIndex) !== null && _c !== void 0 ? _c : ''}:${(_d = b.operator) !== null && _d !== void 0 ? _d : ''}`; })
                    .join(',');
                const signature = `${datasetRefs.map(r => r.id).join('+')}|${filters.map(f => `${f.id}:${f.label}:${f.type}:${f.sourceDatasetId}:${f.valueColumn}`).join(',')}|${referencedIds}|${bindingTargets}`;
                if (signature === this._lastSignature && this.$list.children().length > 0) {
                    this.setVisibility(true);
                    return;
                }
                this._lastSignature = signature;
                this.$list.empty();
                this.setVisibility(true);
                filters.forEach(filter => {
                    const binding = bindings.find(b => b.globalFilterId === filter.id);
                    this.$list.append(this.buildRow(component, filter, datasetRefs, binding));
                });
                appn.select.initForDesign({
                    elements: this.$list.find('select').not('.select2-hidden-accessible'),
                    omitWidth: true,
                    minimumResultsForSearch: GLOBAL_FILTER_BINDING_MIN_RESULTS_FOR_SEARCH
                });
            }
            bindEvents() {
                this.subscribeToEvent(distill.EVENTS.STATE_CHANGED, () => this.update());
                this.$list.on('change', '.global-filter-binding-column', e => {
                    const filterId = $(e.currentTarget).data('filter-id');
                    const val = $(e.target).val() || '';
                    if (val.startsWith('metric|'))
                        this.setBinding(filterId, 0, null, parseInt(val.split('|')[1], 10));
                    else if (val) {
                        const [datasetIndexStr, columnId] = val.split('|');
                        this.setBinding(filterId, parseInt(datasetIndexStr, 10), columnId);
                    }
                    else
                        this.setBinding(filterId, 0, null);
                });
                this.$list.on('change', '.global-filter-binding-operator', e => {
                    const filterId = $(e.currentTarget).data('filter-id');
                    const val = $(e.target).val() || '';
                    if (val)
                        this.setBindingOperator(filterId, val);
                });
            }
            setBinding(filterId, datasetIndex, columnId, metricIndex) {
                const bindings = (this.getValueForEdit() || []).slice();
                const existing = bindings.find(b => b.globalFilterId === filterId);
                const isMetric = metricIndex != null;
                const updated = {
                    globalFilterId: filterId,
                    datasetIndex: isMetric ? undefined : datasetIndex,
                    columnId: !isMetric && columnId ? columnId : undefined,
                    metricIndex: isMetric ? metricIndex : undefined,
                    operator: isMetric ? undefined : existing === null || existing === void 0 ? void 0 : existing.operator
                };
                const index = bindings.findIndex(b => b.globalFilterId === filterId);
                if (index >= 0)
                    bindings[index] = updated;
                else
                    bindings.push(updated);
                this.setValue(bindings);
            }
            setBindingOperator(filterId, operator) {
                const bindings = (this.getValueForEdit() || []).slice();
                const index = bindings.findIndex(b => b.globalFilterId === filterId);
                if (index < 0)
                    return;
                bindings[index] = Object.assign(Object.assign({}, bindings[index]), { operator });
                this.setValue(bindings);
            }
            buildRow(component, filter, datasetRefs, binding) {
                var _a, _b;
                const $row = appn.utils.cloneTemplate('globalFilterBindingRow');
                $row.find('.global-filter-binding-label').text(filter.label || '').attr('title', filter.label || '');
                const $columnCol = $row.find('.global-filter-binding-column-col');
                const $operatorCol = $row.find('.global-filter-binding-operator-col');
                const $select = $row.find('.global-filter-binding-column');
                const $warning = $row.find('.global-filter-binding-warning');
                if (this.isFilterOverridden(component, filter.id)) {
                    $select.addClass('d-none');
                    $columnCol.find('.global-filter-binding-overridden').removeClass('d-none');
                    return $row;
                }
                const selectedValue = (binding === null || binding === void 0 ? void 0 : binding.metricIndex) != null
                    ? `metric|${binding.metricIndex}`
                    : ((binding === null || binding === void 0 ? void 0 : binding.columnId) ? `${(_a = binding.datasetIndex) !== null && _a !== void 0 ? _a : 0}|${binding.columnId}` : '');
                const availableTargets = this.populateBindingTargets($select, filter, datasetRefs, ((_b = component.dataQuery0) === null || _b === void 0 ? void 0 : _b.aggregation) || null, selectedValue);
                if (availableTargets === 0) {
                    $select.addClass('d-none');
                    $warning.text(T(`No suitable column for '{0}' in this widget's datasets. Update the dataset or remove the global filter.`, filter.label || '')).removeClass('d-none');
                    return $row;
                }
                $select.attr('data-filter-id', filter.id);
                if (filter.type === dashboards.DashboardGlobalFilterType.Text && (binding === null || binding === void 0 ? void 0 : binding.columnId)) {
                    $columnCol.removeClass('col-8').addClass('col-4 pr-1');
                    $operatorCol.removeClass('d-none');
                    const $operatorSelect = $operatorCol.find('.global-filter-binding-operator');
                    $operatorSelect.attr('data-filter-id', filter.id);
                    const { columnMeta } = dashboards.getContextualColumnMeta(binding.datasetIndex, binding.columnId, datasetRefs, dashboards.designer.getDatasets() || []);
                    const isTextColumn = (columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.type) === 'Text' || (columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.type) === 'LongText';
                    const operators = [
                        { value: 'Equals', label: T('equals') },
                        { value: 'NotEquals', label: T('not equals') },
                        { value: 'Contains', label: T('contains') },
                        { value: 'NotContains', label: T('does not contain') },
                        { value: 'StartsWith', label: T('starts with') },
                        { value: 'NotStartsWith', label: T('does not start with') },
                        { value: 'EndsWith', label: T('ends with') },
                        { value: 'NotEndsWith', label: T('does not end with') }
                    ];
                    operators
                        .filter(op => isTextColumn || !TEXT_SEARCH_OPERATORS.includes(op.value))
                        .forEach(op => $operatorSelect.append($('<option>').val(op.value).text(op.label)));
                    $operatorSelect.val(binding.operator || (isTextColumn ? 'Contains' : 'Equals'));
                }
                return $row;
            }
            populateBindingTargets($select, filter, datasetRefs, aggregation, selectedValue) {
                var _a, _b, _c, _d, _e;
                const allDatasets = dashboards.designer.getDatasets() || [];
                const compatibleTypes = dashboards.getGlobalFilterCompatibleColumnTypes(filter, allDatasets);
                const showPrefix = datasetRefs.length > 1;
                $select.empty().append($('<option>').val('').text(T('Choose column...')));
                const buildTargetText = (datasetRef, dataset, columnMeta) => {
                    const columnText = dashboards.getColumnOptionText(columnMeta);
                    return showPrefix ? `${datasetRef.alias || dataset.name}.${columnText}` : columnText;
                };
                const groupTargetValue = ((_a = aggregation === null || aggregation === void 0 ? void 0 : aggregation.groupBy) === null || _a === void 0 ? void 0 : _a.columnId)
                    ? `${(_b = aggregation.groupBy.datasetIndex) !== null && _b !== void 0 ? _b : 0}|${aggregation.groupBy.columnId}` : null;
                const breakDownTargetValue = ((_c = aggregation === null || aggregation === void 0 ? void 0 : aggregation.breakDownBy) === null || _c === void 0 ? void 0 : _c.columnId)
                    ? `${(_d = aggregation.breakDownBy.datasetIndex) !== null && _d !== void 0 ? _d : 0}|${aggregation.breakDownBy.columnId}` : null;
                let count = 0;
                const $columnsGroup = $('<optgroup>').attr('label', T('Columns'));
                datasetRefs.forEach((datasetRef, index) => {
                    const dataset = allDatasets.find(t => t.id === datasetRef.id);
                    if (!dataset)
                        return;
                    dataset.columns.forEach(col => {
                        if (!compatibleTypes.includes(col.type))
                            return;
                        const value = `${index}|${col.id}`;
                        if (value === groupTargetValue || value === breakDownTargetValue)
                            return;
                        $columnsGroup.append($('<option>').val(value).text(buildTargetText(datasetRef, dataset, col)));
                        count++;
                    });
                });
                if (count > 0)
                    $select.append($columnsGroup);
                if (aggregation) {
                    const groupOptions = [];
                    const addGroupTarget = (identifier) => {
                        var _a;
                        if (!(identifier === null || identifier === void 0 ? void 0 : identifier.columnId))
                            return;
                        const { datasetRef, dataset, columnMeta } = dashboards.getContextualColumnMeta(identifier.datasetIndex, identifier.columnId, datasetRefs, allDatasets);
                        if (!datasetRef || !dataset || !columnMeta || !compatibleTypes.includes(columnMeta.type))
                            return;
                        groupOptions.push({ value: `${(_a = identifier.datasetIndex) !== null && _a !== void 0 ? _a : 0}|${identifier.columnId}`, text: buildTargetText(datasetRef, dataset, columnMeta) });
                    };
                    addGroupTarget(aggregation.groupBy);
                    addGroupTarget(aggregation.breakDownBy);
                    if (groupOptions.length > 0) {
                        const $groups = $('<optgroup>').attr('label', T('Groups'));
                        groupOptions.forEach(o => $groups.append($('<option>').val(o.value).text(o.text)));
                        $select.append($groups);
                        count += groupOptions.length;
                    }
                    if (filter.type === dashboards.DashboardGlobalFilterType.NumberRange && ((_e = aggregation.metrics) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                        const $metricsGroup = $('<optgroup>').attr('label', T('Metrics'));
                        aggregation.metrics.forEach((m, index) => {
                            $metricsGroup.append($('<option>').val(`metric|${index}`).text(dashboards.getMetricDisplayText(m, index, aggregation, datasetRefs, allDatasets)));
                        });
                        $select.append($metricsGroup);
                        count += aggregation.metrics.length;
                    }
                }
                if (selectedValue)
                    $select.val(selectedValue);
                return count;
            }
            isFilterOverridden(component, filterId) {
                const query = component.dataQuery0;
                if (!query)
                    return false;
                return referencesGlobalFilterInCriteria(query.filter, filterId)
                    || referencesGlobalFilterInAggCriteria(query.aggregationFilter, filterId);
            }
            getGlobalFilters() {
                const design = dashboards.designer._design;
                return (design && design.globalFilters) ? design.globalFilters : [];
            }
        }
        dashboards.GlobalFilterBindingsEditor = GlobalFilterBindingsEditor;
        distill.editors.register('globalFilterBindings', GlobalFilterBindingsEditor);
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
